import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import PageLoader from "./ui/PageLoader";
import { useSiteTranslation } from "./pages/home/i18n";

export default function ProtectedRoute() {
  const { currentUser, getCurrentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const { t } = useSiteTranslation();

  useEffect(() => {
    getCurrentUser()
      .catch(() => {
        // Not signed in; the redirect below handles it.
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <PageLoader label={t("common.connecting")} />;
  return currentUser ? <Outlet /> : <Navigate to="/login" replace />;
}
